var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 43,
    viewBox: "0 0 13 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13386 1.64514C5.26871 1.64514 4.5596 2.34733 4.5596 3.21247V12.6793H7.70828V3.21247C7.70828 2.34733 6.999 1.64514 6.13386 1.64514Z",
    fill: "#BFD6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36052 31.3649V3.2053C9.36052 1.4821 7.94222 0 6.13393 0C4.32564 0 2.82943 1.48919 2.82943 3.2053V31.3649C1.09915 32.457 0 34.4142 0 36.4494C0 39.8107 2.75137 42.548 6.13393 42.548C9.5165 42.548 12.19 39.8107 12.19 36.4494C12.197 34.4142 11.1688 32.4641 9.36052 31.3649ZM7.70836 12.6721H4.55968V3.2053C4.55968 2.34724 5.26879 1.63814 6.13393 1.63814C6.99907 1.63814 7.70836 2.34015 7.70836 3.2053V12.6721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.ae23ea387f0b5ac88de30b67baa8661e.svg";
export { ForwardRef as ReactComponent };